(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueCountUp"] = factory();
	else
		root["VueCountUp"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _countup = __webpack_require__(6);

var _countup2 = _interopRequireDefault(_countup);

var _extend = __webpack_require__(5);

var _extend2 = _interopRequireDefault(_extend);

var _dom = __webpack_require__(1);

var _event = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createCountUp(vm) {
  var countup = new _countup2.default(vm.$el, vm.startValue, vm.endValue, vm.decimals, vm.duration, vm.options);
  return countup;
}

var defaultsOptions = {
  useEasing: true, // toggle easing
  useGrouping: true, // 1,000,000 vs 1000000
  separator: ',', // character to use as a separator
  decimal: '.', // character to use as a decimal
  prefix: '', // optional text before the result
  suffix: '' // optional text after the result
};

var twoTypes = [Number, String];
var stringOrArray = [String, Array];
exports.default = {
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    startValue: {
      type: twoTypes,
      default: 0
    },
    endValue: {
      type: twoTypes,
      default: 0
    },
    // number of decimal places, default 0
    decimals: {
      type: twoTypes,
      default: 0
    },
    // duration of animation in seconds, default 2
    duration: {
      type: twoTypes,
      default: 2
    },
    // optional object of options (see below)
    options: {
      type: Object,
      default: function _default() {
        return (0, _extend2.default)({}, defaultsOptions);
      }
    },
    immediate: {
      type: Boolean,
      default: true
    },
    delay: {
      type: twoTypes,
      default: 0
    },
    animateClass: {
      type: stringOrArray,
      required: false
    },
    animatedClass: {
      type: String,
      default: 'animated'
    }
  },
  data: function data() {
    return {
      oldVal: null,
      delayTimeout: null
    };
  },

  computed: {
    computedClass: function computedClass() {
      var className = this.animateClass;
      if (typeof className === 'string' && className !== '') {
        return className.includes(' ') ? className.split(' ') : className;
      } else if (Array.isArray(className)) {
        return className;
      }
      return null;
    }
  },
  mounted: function mounted() {
    this.createCountUp();
    if (this.immediate) {
      this.start();
    } else {
      this.jumpToEndValue();
    }
  },

  methods: {
    createCountUp: function createCountUp() {
      if (this._countup) {
        this._countup.reset();
        this._countup = null;
      }
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
      this._countup = _createCountUp(this);
    },
    jumpToEndValue: function jumpToEndValue() {
      if (this._countup) {
        this._countup.reset();
      }
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
      if (this.$el.innerText) {
        this.$el.innerText = this.endValue;
      } else if (this.$el.textContent) {
        this.$el.innerText = this.endValue;
      }
    },
    recreateCountUp: function recreateCountUp() {
      this.createCountUp();
      if (this.immediate) {
        this.start();
      }
    },
    start: function start() {
      var vm = this;
      var delay = Math.max(+this.delay, 0);
      function cancel() {
        vm.$el.removeEventListener(_event.animationEnd, cancel);
      }
      function _start() {
        if (vm.computedClass && !(0, _dom.hasClass)(vm.$el, vm.computedClass)) {
          if (!(0, _dom.hasClass)(vm.$el, vm.animatedClass)) {
            (0, _dom.addClass)(vm.$el, vm.animatedClass);
            vm.$el.offsetWidth;
          }
          vm.$el.addEventListener(_event.animationEnd, cancel, false);
          (0, _dom.addClass)(vm.$el, vm.computedClass);
        }
        vm._countup.start(function (lastTime) {
          if (vm.computedClass && (0, _dom.hasClass)(vm.$el, vm.computedClass)) {
            (0, _dom.removeClass)(vm.$el, vm.computedClass);
            vm.$el.removeEventListener(_event.animationEnd, cancel);
          }
          vm.$emit('callback', vm, vm._countup);
        });
      }

      if (delay > 0) {
        if (this.delayTimeout) {
          clearTimeout(this.delayTimeout);
        }
        this.delayTimeout = setTimeout(_start, delay * 1000);
      } else {
        _start();
      }
    },
    update: function update(val) {
      val = Number(val);
      if (isNaN(val)) {
        console.error('[vue-countupjs] update() Error! the val is not validate number');
        return;
      }
      if (val === this.oldVal) {
        return;
      }
      this.oldVal = val;
      if (this.computedClass && !(0, _dom.hasClass)(this.$el, this.computedClass)) {
        (0, _dom.addClass)(this.$el, this.computedClass);
      }
      this._countup.update(val);
    },
    pauseResume: function pauseResume() {
      this._countup.pauseResume();
    },
    reset: function reset() {
      this._countup.reset();
    }
  },
  render: function render(h) {
    return h(this.tag, {}, '');
  },

  watch: {
    startValue: function startValue(val) {
      val = Number(val);
      if (isNaN(val)) {
        console.warn('[vue-countupjs] Warning ! the prop startValue is not number');
        return;
      }
      this.recreateCountUp();
    },
    endValue: function endValue(val) {
      val = Number(val);
      if (isNaN(val)) {
        console.error('[vue-countupjs] Error! endValue is not number');
        return;
      }
      this.recreateCountUp();
    },
    decimals: function decimals(val) {
      val = Number(val);
      if (isNaN(val)) {
        console.error('[vue-countupjs] Error! decimals is not number');
        return;
      }
      if (val > 20) {
        console.error('[vue-countupjs] Error! decimals over limit, the max decimals is 20');
        return;
      }
      this.recreateCountUp();
    },
    duration: function duration(val) {
      val = Number(val);
      if (isNaN(val)) {
        console.error('[vue-countupjs] Error! duration is not number');
        return;
      }
      this.recreateCountUp();
    },
    delay: function delay(val) {
      val = Number(val);
      if (isNaN(val)) {
        console.error('[vue-countupjs] Error! delay is not number');
        return;
      }
      this.recreateCountUp();
    },

    options: {
      deep: true,
      handler: function handler(val) {
        var countup = this._countup;
        if (val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
          for (var key in countup.options) {
            if (val.hasOwnProperty(key) && val[key] !== null) {
              countup.options[key] = val[key];
            }
          }
        }
        if (countup.options.separator === '') {
          countup.options.useGrouping = false;
        }
      }
    }
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;

var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) {
    return false;
  }
  if (Array.isArray(cls)) {
    var results = cls.map(function (item) {
      return hasClass(el, item);
    });
    return results.indexOf(false) === -1;
  }
  if (cls.indexOf(' ') !== -1) {
    throw new Error('className should not contain space.');
  }
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = Array.isArray(cls) ? cls : (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = Array.isArray(cls) ? cls : cls.split(' ');
  var curClass = ' ' + el.className + ' ';
  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

var inBrowser = exports.inBrowser = typeof window !== 'undefined';

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = install;

var _component = __webpack_require__(0);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  name: 'v-countup'
};

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (install.installed) {
    return;
  }
  var globalOptions = Vue.util.extend({}, defaultOptions, options);
  Vue.component(globalOptions.name, _component2.default);
  install.installed = true;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _component = __webpack_require__(0);

var _component2 = _interopRequireDefault(_component);

var _install = __webpack_require__(2);

var _install2 = _interopRequireDefault(_install);

var _dom = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_component2.default.version = "1.0.0";
_component2.default.install = _install2.default;

module.exports = _component2.default;

if (_dom.inBrowser && window.Vue) {
  window.Vue.use(_component2.default);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var animationEnd = exports.animationEnd = function () {
    var eleStyle = document.createElement('div').style;
    var verdors = ['a', 'webkitA', 'MozA', 'OA', 'msA'];
    var endEvents = ['animationend', 'webkitAnimationEnd', 'animationend', 'oAnimationEnd', 'MSAnimationEnd'];
    var animation = void 0;
    for (var i = 0, len = verdors.length; i < len; i++) {
        animation = verdors[i] + 'nimation';
        if (animation in eleStyle) {
            return endEvents[i];
        }
    }
    return 'animationend';
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (to) {
  if (to instanceof Object === true) {
    return null;
  }
  var args = Array.prototype.slice.call(arguments, 1);
  for (var i = 0, len = args.length; i < len; i++) {
    var from = args[i];
    for (var key in from) {
      to[key] = from[key];
    }
  }
  return to;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require, exports, module);
  } else {
    root.CountUp = factory();
  }
}(this, function(require, exports, module) {

/*

	countUp.js
	by @inorganik

*/

// target = id of html element or var of previously selected html element where counting occurs
// startVal = the value you want to begin at
// endVal = the value you want to arrive at
// decimals = number of decimal places, default 0
// duration = duration of animation in seconds, default 2
// options = optional object of options (see below)

var CountUp = function(target, startVal, endVal, decimals, duration, options) {

	// make sure requestAnimationFrame and cancelAnimationFrame are defined
	// polyfill for browsers without native support
	// by Opera engineer Erik Möller
	var lastTime = 0;
	var vendors = ['webkit', 'moz', 'ms', 'o'];
	for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame =
		  window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); },
			  timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	}
	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
	}

	var self = this;
    self.version = function () { return '1.8.5'; };

	function formatNumber(num) {
		num = num.toFixed(self.decimals);
		num += '';
		var x, x1, x2, rgx;
		x = num.split('.');
		x1 = x[0];
		x2 = x.length > 1 ? self.options.decimal + x[1] : '';
		rgx = /(\d+)(\d{3})/;
		if (self.options.useGrouping) {
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + self.options.separator + '$2');
			}
		}
		return self.options.prefix + x1 + x2 + self.options.suffix;
	}
	// Robert Penner's easeOutExpo
	function easeOutExpo(t, b, c, d) {
		return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
	}
	function ensureNumber(n) {
		return (typeof n === 'number' && !isNaN(n));
	}
	
	// default options
	self.options = {
		useEasing: true, // toggle easing
		useGrouping: true, // 1,000,000 vs 1000000
		separator: ',', // character to use as a separator
		decimal: '.', // character to use as a decimal
		easingFn: easeOutExpo, // optional custom easing function, default is Robert Penner's easeOutExpo
		formattingFn: formatNumber, // optional custom formatting function, default is formatNumber above
		prefix: '', // optional text before the result
		suffix: '' // optional text after the result
	};

	// extend default options with passed options object
	if (options && typeof options === 'object') {
		for (var key in self.options) {
			if (options.hasOwnProperty(key) && options[key] !== null) {
				self.options[key] = options[key];
			}
		}
	}

	if (self.options.separator === '') self.options.useGrouping = false;

	self.initialize = function() { 
		if (self.initialized) return true;
		self.d = (typeof target === 'string') ? document.getElementById(target) : target;
		if (!self.d) { 
			console.error('[CountUp] target is null or undefined', self.d);
			return false;
		}
		self.startVal = Number(startVal);
		self.endVal = Number(endVal);
		// error checks
		if (ensureNumber(self.startVal) && ensureNumber(self.endVal)) {
			self.decimals = Math.max(0, decimals || 0);
			self.dec = Math.pow(10, self.decimals);
			self.duration = Number(duration) * 1000 || 2000;
			self.countDown = (self.startVal > self.endVal);
			self.frameVal = self.startVal;
			self.initialized = true;
			return true;
		}
		else {
			console.error('[CountUp] startVal or endVal is not a number', self.startVal, self.endVal);
			return false;
		}
	};

	// Print value to target
	self.printValue = function(value) {
		var result = self.options.formattingFn(value);

		if (self.d.tagName === 'INPUT') {
			this.d.value = result;
		}
		else if (self.d.tagName === 'text' || self.d.tagName === 'tspan') {
			this.d.textContent = result;
		}
		else {
			this.d.innerHTML = result;
		}
	};

	self.count = function(timestamp) {
		if (!self.startTime) { self.startTime = timestamp; }

		self.timestamp = timestamp;
		var progress = timestamp - self.startTime;
		self.remaining = self.duration - progress;

		// to ease or not to ease
		if (self.options.useEasing) {
			if (self.countDown) {
				self.frameVal = self.startVal - self.options.easingFn(progress, 0, self.startVal - self.endVal, self.duration);
			} else {
				self.frameVal = self.options.easingFn(progress, self.startVal, self.endVal - self.startVal, self.duration);
			}
		} else {
			if (self.countDown) {
				self.frameVal = self.startVal - ((self.startVal - self.endVal) * (progress / self.duration));
			} else {
				self.frameVal = self.startVal + (self.endVal - self.startVal) * (progress / self.duration);
			}
		}

		// don't go past endVal since progress can exceed duration in the last frame
		if (self.countDown) {
			self.frameVal = (self.frameVal < self.endVal) ? self.endVal : self.frameVal;
		} else {
			self.frameVal = (self.frameVal > self.endVal) ? self.endVal : self.frameVal;
		}

		// decimal
		self.frameVal = Math.round(self.frameVal*self.dec)/self.dec;

		// format and print value
		self.printValue(self.frameVal);
	
		// whether to continue
		if (progress < self.duration) {
			self.rAF = requestAnimationFrame(self.count);
		} else {
			if (self.callback) self.callback();
		}
	};
	// start your animation
	self.start = function(callback) {
		if (!self.initialize()) return;
		self.callback = callback;
		self.rAF = requestAnimationFrame(self.count);
	};
	// toggles pause/resume animation
	self.pauseResume = function() {
		if (!self.paused) {
			self.paused = true;
			cancelAnimationFrame(self.rAF);
		} else {
			self.paused = false;
			delete self.startTime;
			self.duration = self.remaining;
			self.startVal = self.frameVal;
			requestAnimationFrame(self.count);
		}
	};
	// reset to startVal so animation can be run again
	self.reset = function() {
		self.paused = false;
		delete self.startTime;
		self.initialized = false;
		if (self.initialize()) {
			cancelAnimationFrame(self.rAF);
			self.printValue(self.startVal);
		}
	};
	// pass a new endVal and start animation
	self.update = function (newEndVal) {
		if (!self.initialize()) return;
		if (newEndVal === self.frameVal) return;
		cancelAnimationFrame(self.rAF);
		self.paused = false;
		delete self.startTime;
		self.startVal = self.frameVal;
		self.endVal = Number(newEndVal);
		if (ensureNumber(self.endVal)) {
			self.countDown = (self.startVal > self.endVal);
			self.rAF = requestAnimationFrame(self.count);
		} else {
			console.error('[CountUp] update() - new endVal is not a number', newEndVal);
		}
	};

	// format startVal on initialization
	if (self.initialize()) self.printValue(self.startVal);
};

return CountUp;

}));


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-countup.min.js